<template>
<div style="padding-left: 20px;padding-right:20px;">
   <table width="100%">
    <tr>
      <td width="20%" style="vertical-align: middle;">
      <table width="100%" height="50px;">
        <tr>
          <td width="auto">
          </td>
          <td width="50px" style="text-align:right;">
            <v-img
              v-if="data && data.IconListImage"
              style="width: 50px; height: 50px;postion: absolute; right:0px;"
              :src="data.IconListImage"        
            />
          </td>
        </tr></table>
      </td>
      <td width="80%" style="vertical-align: middle;line-height:1; padding-left: 10px;"
        :style="{ 'font-family' : FontContent, 'font-size': `${FontSizeContent}px`, 'color': customTextColorContent ? customTextColorContent : ColorContent}"
      >
      {{IconListTitle}}<br />
      <span style="opacity: 70%" :style="{ 'font-size': `${FontSizeContent -2}px`}">{{IconListDescription}}</span>
      </td>
    </tr>
   </table>
  </div>
</template>

<script>
  import {
    mapState
  } from 'vuex'
  import constants from '@/constants'
  import utils from '@/services/utils'
  export default {
    props: {
      data: {
        type: Object,
        required: true,
        default: null
      },
      customTextColorContent: {
        type: String,
        required: false,
        default: null
      },
    },
    data: () => ({
    }),
    computed: {
      ...mapState('app',['locale', 'FontContent', 'FontSizeContent', 'ColorContent']),
      IconListTitle () {
        return this.data.IconListTitle ? utils.getTranslation (this.data.IconListTitle, this.locale) : ''
      },
      IconListDescription () {
        return this.data.IconListDescription ? utils.getTranslation (this.data.IconListDescription, this.locale) : ''
      },
      isSimulation () {
        return constants.simulationsRutes.indexOf(this.$route.path.split('/')[1]) >= 0
      },
      isDesktop () {
        return !utils.isMobile()
      }
    },
  }
</script>
